<script>
  import { Button, Pagination, PaginationItem } from "sveltestrap";

  export let total = 0;
  export let xpage = 10;
  export let current = 1;
  export let onPageClick;

  let pages = [];

  $: if (total > 0 && xpage > 0 && current > 0) {
    pages = buildPageRange();
  } else {
    pages = [];
  }

  function buildPageRange() {
    const visiblePages = 5;
    const totalPages = Math.ceil(total / xpage);
    const middle = Math.ceil(visiblePages / 2);

    let start = Math.max(1, current - middle + 1);
    let end = Math.min(totalPages, current + middle - 1);

    const shown = end - start + 1;
    if (shown < visiblePages) {
      if (start === 1) {
        end = Math.min(totalPages, end + (visiblePages - shown));
      } else if (end === totalPages) {
        start = Math.max(1, start - (visiblePages - shown));
      }
    }

    const range = [];
    for (let i = start; i <= end; i++) range.push(i);
    return range;
  }

  function changePage(page) {
    const totalPages = Math.ceil(total / xpage);
    if (page < 1 || page > totalPages || page === current) return;
    onPageClick(page);
  }
</script>

<nav class="pagination">
  <span class="total-info">Total {total} items.</span>

  <Pagination>
    <PaginationItem disabled={current === 1}>
      <Button class="page-link" on:click={() => changePage(current - 1)}>
        <span aria-hidden="true">&laquo;</span>
      </Button>
    </PaginationItem>

    {#each pages as page}
      <PaginationItem active={current === page}>
        <Button class="page-link" on:click={() => changePage(page)}>
          {page}
        </Button>
      </PaginationItem>
    {/each}

    <PaginationItem disabled={current === Math.ceil(total / xpage)}>
      <Button class="page-link" on:click={() => changePage(current + 1)}>
        <span aria-hidden="true">&raquo;</span>
      </Button>
    </PaginationItem>
  </Pagination>
</nav>



<style>
  .pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 1em 0; /* Add some margin for better visual separation */
  }

  .total-info {
    color: black;
    margin-right: 1em; /* Separate the total information from the pagination buttons */
  }
  @media (max-width: 768px) {
    .pagination {
      /* Adjust pagination layout for smaller screens (optional) */
      flex-wrap: wrap;
    }
  }
</style>
